import { render, staticRenderFns } from "./MForm.vue?vue&type=template&id=fbe6c118&scoped=true&"
import script from "./MForm.vue?vue&type=script&lang=js&"
export * from "./MForm.vue?vue&type=script&lang=js&"
import style0 from "./MForm.vue?vue&type=style&index=0&id=fbe6c118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe6c118",
  null
  
)

export default component.exports